"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backups = void 0;
var client_1 = require("../../shared/http/client");
var headers_1 = require("../../shared/headers");
var Backups = /** @class */ (function () {
    function Backups(apiUrl, appDetails, apiSecurity) {
        this.client = client_1.HttpClient.create(apiUrl, apiSecurity.unauthorizedCallback);
        this.appDetails = appDetails;
        this.apiSecurity = apiSecurity;
    }
    Backups.client = function (apiUrl, appDetails, apiSecurity) {
        return new Backups(apiUrl, appDetails, apiSecurity);
    };
    Backups.prototype.getAllDevices = function () {
        return this.client
            .get('/backup/device', this.headers());
    };
    Backups.prototype.getAllBackups = function (mac) {
        return this.client
            .get("/backup/" + mac, this.headers());
    };
    Backups.prototype.deleteBackup = function (backupId) {
        return this.client
            .delete("/backup/" + backupId, this.headers());
    };
    Backups.prototype.deleteDevice = function (deviceId) {
        return this.client
            .delete("/backup/device/" + deviceId, this.headers());
    };
    /**
     * Returns the needed headers for the module requests
     * @private
     */
    Backups.prototype.headers = function () {
        return (0, headers_1.headersWithToken)(this.appDetails.clientName, this.appDetails.clientVersion, this.apiSecurity.token);
    };
    return Backups;
}());
exports.Backups = Backups;
